<template>
  <v-container>
    <v-card :dark="config.dark_background" :color="config.background_dark">
      <v-container>
        <v-row justify="center">
          <v-card-title>
            Change Password
          </v-card-title>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <div v-if="errors.length >= 1" class="container">
              <v-alert
              v-bind:color="config.alert"
              class="m-2"
              dark
              >
                <ul>
                  <li
                    v-bind:key="index"
                    v-for="(error, index) in errors"
                    class="mb-2 mt-2"
                  >
                  <strong>{{ error.error }}</strong>
                  </li>
                </ul>
              </v-alert>
            </div>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6">
            <v-text-field type="password" :error="error" v-model="password" label="New Password">

            </v-text-field>
            <v-text-field type="password" :error="error" v-model="confirmPassword" label="Confirm New Password">

            </v-text-field>
            <v-row justify="center">
              <v-btn :loading="loading" @click="changePassword()" :color="config.primary" :dark="config.dark_primary">
                Confirm Password Reset
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-dialog persistent v-model="successDialog" width="450">
      <modal>
        <template v-slot:toolbar>
          <v-toolbar 
          v-bind:color="config.primary"
          dark
          flat
          >
            <h3>
              Your password has been changed!
            </h3>
          </v-toolbar>
        </template>
        <template v-slot:title>
          <div>

          </div>
        </template>
        <template v-slot:text>
          <v-card-text>
            Your password has been successfully changed. Please close this window.
          </v-card-text>
        </template>
        <template v-slot:actions>
          <div>

          </div>
        </template>
      </modal>
    </v-dialog>
  </v-container>
</template>

<script>
import config from '@/config/config'
import { mapGetters } from 'vuex'
import UserService from '@/services/UserService'
import Modal from '@/components/Modal'
export default {
  name: 'changepassword',
  data() {
    return {
      config,
      signed: null,
      password: '',
      confirmPassword: '',
      loading: false,
      error: false,
      errors: [],
      successDialog: false
    }
  },
  methods: {
    navigateTo (route) {
      this.$router.push(route)
    },
    logOut () {
      this.$store.dispatch('logout')
    },
    async changePassword () {
      this.error = false
      this.errors = []
      if (this.password != this.confirmPassword) {
        this.errors.push({error: 'Passwords do not match'})
      }
      if (this.password.length < 6) {
        this.errors.push({error: 'Your password must be at least 6 characters long'})
      }
      if (this.errors.length == 0) {
        this.loading = true
        UserService.changePasswordSigned({token: this.signed, password: this.password}).then(response => {
          if (response.status == 200) {
            this.loading = false
            this.logOut()
            this.successDialog = true
          }
        }).catch(error => {
          this.errors.push(error.response.data)
          this.error = true
          this.loading = false
        })
      } else {
        this.error = true
      }
    }
  },
  computed: {
    ...mapGetters({
      loggedIn: 'loggedIn',
      getSearchInfo: 'getSearchInfo',
      getUser: 'getUser'
    })
  },
  mounted () {
    this.signed = this.$route.query.signed
  },
  components: {
    Modal
  }
}
</script>

<style scoped>

</style>